import React, { useState } from 'react';
import CourseInput from './components/CourseInput';
import Timetable from './components/Timetable';
import { TimetableEntry, UnmetPreference } from './types';

function App() {
  const [timetable, setTimetable] = useState<TimetableEntry[]>([]);
  const [unmetPreferences, setUnmetPreferences] = useState<UnmetPreference[]>([]);
  const [showTimetable, setShowTimetable] = useState(false);

  const handleTimetableGenerated = (data: any) => {
    console.log('Received timetable data:', data);
    setTimetable(data.timetable || []);
    setUnmetPreferences(data.unmetPreferences || []);
    setShowTimetable(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900">
            Simple Course Timetabling System
          </h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <CourseInput onTimetableGenerated={handleTimetableGenerated} />
        
        {showTimetable && timetable.length > 0 && (
          <Timetable
            timetable={timetable}
            unmetPreferences={unmetPreferences}
          />
        )}
      </main>
    </div>
  );
}

export default App;
